import {
  type QueryFunctionContext,
  useInfiniteQuery,
} from '@tanstack/react-query'

import { useFetchDocumentImages } from '../useFetchDocumentImages'

import { useDocumentImagesInfiniteQueryKey } from './useDocumentImagesInfiniteQueryKey'

type QueryKey = ReturnType<typeof useDocumentImagesInfiniteQueryKey>
type PageParam = number

export const useDocumentImagesInfiniteQuery = () => {
  const fetchDocumentImages = useFetchDocumentImages()
  const queryKey = useDocumentImagesInfiniteQueryKey()

  return useInfiniteQuery({
    queryFn: ({
      pageParam: offset,
      queryKey: [_, variables],
    }: QueryFunctionContext<QueryKey, PageParam>) =>
      fetchDocumentImages({ ...variables, offset }),
    queryKey,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages): PageParam | undefined =>
      0 < lastPage.length ? allPages.flat().length : undefined,
  })
}
